module.exports = __webpack_public_path__ + "static/media/cover1-2.88dc2c7c.png";